import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useDialog } from '../dialog/DialogContext';
import { ExportDialog } from '../dialog/ExportDialog';
import { TitleButton } from './TitleButton';

export const ExportButton = ({ exportReq, disabled }) => {
  const { openDialog } = useDialog();

  const openExportDialog = () => {
    const finalExportReq = typeof exportReq === 'function' ? exportReq() : exportReq;
    openDialog(ExportDialog, { data: finalExportReq });
  };

  return (
    <TitleButton
      dataTestId="export-button"
      icon={fas.faArrowCircleDown}
      toolTip="Export"
      disabled={disabled}
      onClick={openExportDialog}
    />
  );
};
